import React, {PureComponent} from "react";
import Select, {components} from 'react-select';
import {Trans} from "react-i18next";

const customStyles  = {
    indicatorSeparator: () => ({
        display: 'none'
    }),
};

const customTheme = theme => ({
    ...theme,
    borderRadius: '5px',
    colors: {
        ...theme.colors,
        primary25: 'rgba(107,112,139,0.1)',
        primary50: 'rgba(107,112,139,0.3)',
        primary: '#6B708B',
    },
});

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            {' '}
        </components.DropdownIndicator>
    );
};

const SingleValue = ({data}) => (
    <div className="input-select">
        <div className="input-select__single-value">
            { data.icon && <span className="input-select__icon">{ data.icon }</span> }
            <span>{ data.label }</span>
        </div>
    </div>
);

const Option = (props) => (
    <components.Option {...props}>
        { props.data.icon && <span className="input-select__icon">{ props.data.icon }</span> }
        {props.label}
    </components.Option>
);

class SelectField extends PureComponent {
    handleChange = option => {
        const {input} = this.props;
        input.onChange(option.value)
    };

    getValue = () => {
        const {input: {value}, options} = this.props;
        return options.find(item => item.value === value);
    };

    render() {
        const {
            input,
            meta: {touched, error, warning, invalid},
            options, isSearchable,
            placeholder,
            label,
            className,
            touch,
            classNamePrefix = 'react-select'
        } = this.props;

        return (
            <span className={`${className} ${touched && invalid ? 'has-error' : ''}`}>
                {label && (<label>{label}</label>)}
                <Select
                    {...input}
                    value={this.getValue()}
                    options={options}
                    onChange={value => this.handleChange(value)}
                    onBlur={() => touch && touch(input.name)}  // require for mobile
                    components={{DropdownIndicator, SingleValue, Option}}
                    isSearchable={isSearchable || false}
                    placeholder={placeholder || null}
                    autosize={false}
                    styles={customStyles}
                    theme={customTheme}
                    classNamePrefix={classNamePrefix}
                    // defaultMenuIsOpen={true}
                />
                {touched && (
                    (error && <div className="text-danger scroll-to-error"><Trans>{error}</Trans></div>) ||
                    (warning && <div className="text-warning"><Trans>{warning}</Trans></div>)
                )}
            </span>
        )
    }
}

export default SelectField;